import { getDateFormat2 } from "../helpers/helper";

export class Record {
  _id;
  createdAt;
  device;
  mode;
  patient;
  isReviewed;
  testNumber;

  constructor(_id, createdAt, device, mode, patient, notes, testNumber) {
    this._id = _id;
    this.createdAt = getDateFormat2(createdAt, true);
    this.device = device;
    this.mode = mode;
    this.patient = {
      name: patient?.user.name,
    };
    this.isReviewed = notes[0] === "true" ? true : false;
    this.testNumber = testNumber;
  }
}

export const setRecordParam = (
  limit = 5,
  page,
  fields,
  patientName,
  startDate,
  endDate
) => {
  return new Promise((resolve, reject) => {
    const offset = (page - 1) * limit;
    let param = `limit=${limit}&offset=${offset}&fields=${fields}`;
    if (patientName !== "") param += `&patientName=${patientName}`;
    if (startDate !== "") param += `&startDate=${startDate}`;
    if (endDate !== "") param += `&endDate=${endDate}`;
    if (startDate !== "" && endDate !== "") {
      if (new Date(startDate) > new Date(endDate)) {
        resolve("Interval waktu salah");
      }
    }
    resolve(param);
  });
};
